ixModuleRouting("impactx.orderlimit",{
    "/orderlimitlist": {
        template: "<ixa-orderlimit-list></ixa-orderlimit-list>",
        process: "OrderLimit",
        workspace: "content"
    },
    "/orderlimit/:id": {
        template: "<ixa-orderlimit-dialog></ixa-orderlimit-dialog>",
        process: "OrderLimit",
        workspace: "content"
    }
});